import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const store = {
  get: (k) => { try { return localStorage.getItem(k); } catch (_) { return null; } },
  set: (k, v) => { try { localStorage.setItem(k, v); } catch (_) {} },
  del: (k) => { try { localStorage.removeItem(k); } catch (_) {} },
};

// Bearer fallback for browsers that block cross-site cookies (custom domain + Safari)
const saveTokens = (data) => {
  if (data && typeof data === "object" && data.access_token) {
    store.set("rf_at", data.access_token);
    if (data.refresh_token) store.set("rf_rt", data.refresh_token);
    delete data.access_token;
    delete data.refresh_token;
  }
};

export const clearTokens = () => { store.del("rf_at"); store.del("rf_rt"); };

const authHeader = () => (store.get("rf_at") ? { Authorization: `Bearer ${store.get("rf_at")}` } : {});

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  cfg.headers = { ...cfg.headers, ...authHeader() };
  return cfg;
});

export const refreshSession = async () => {
  const { data } = await axios.post(`${API}/auth/refresh`, { refresh_token: store.get("rf_rt") || "" }, { withCredentials: true });
  saveTokens(data);
};

api.interceptors.response.use(
  (r) => { saveTokens(r.data); return r; },
  async (error) => {
    const cfg = error.config;
    const url = cfg?.url || "";
    if (error.response?.status === 401 && !cfg._retry && !url.includes("/auth/")) {
      cfg._retry = true;
      try {
        await refreshSession();
        return api(cfg);
      } catch (_) {}
    }
    return Promise.reject(error);
  }
);

export function formatError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message === "Network Error" ? "Connessione al server non riuscita. Riprova." : e?.message || "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export const streamAnalysis = (id, onEvent) => streamSSE(`/analyses/${id}/run`, onEvent);

export async function streamSSE(path, onEvent) {
  await refreshSession().catch(() => {});
  const res = await fetch(`${API}${path}`, { method: "POST", credentials: "include", headers: authHeader() });
  if (!res.ok || !res.body) throw new Error("Impossibile avviare l'operazione");
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      const line = p.trim();
      if (line.startsWith("data:")) onEvent(JSON.parse(line.slice(5)));
    }
  }
}
